<template>
  <div id="build-page">
    <div id="fullpage" >
      <div class="section">
        <div class="container">
          <h3>
            1. What We Need From You
          </h3>
          <div class="row">
            <div class="col-md-4"></div>
            <div class="col-md-4">
              <form id="step1" v-on:submit.prevent="verifyStep1(true)" class="small" autocomplete="off">
                <div class="form-group">
                  <input v-model="step1.name" type="text" class="form-control" name="company" placeholder="Company Name *" required>
                </div>
                <div class="form-group">
                  <input v-model="step1.email" type="email" class="form-control" name="email" placeholder="Company Email *" required>
                </div>
                <div class="form-group">
                  <input v-model="step1.fname" type="text" class="form-control" name="fname" placeholder="First Name *" pattern="[a-zA-Z ]+" title="Letters and spaces only." required>
                </div>
                <div class="form-group">
                  <input v-model="step1.lname" type="text" class="form-control" name="lname" placeholder="Last Name *" pattern="[a-zA-Z ]+" title="Letters and spaces only." required>
                </div>
                <div class="form-group">
                  <input v-model="step1.phone" type="tel" class="form-control" name="phone" placeholder="Phone Number *" pattern="[0-9]+" title="Numbers only." minlength="10" maxlength="10" required>
                </div>
                <div class="form-group">
                  <!-- <input v-model="step1.avail" type="text" class="form-control" name="avail" placeholder="Best time to contact *" required> -->
                  <select v-model="step1.avail" class="form-control" required>
                    <option disabled value="">Best time to contact *</option>
                    <option>Morning</option>
                    <option>Afternoon</option>
                    <option>Evening</option>
                  </select>
                </div>
                <button type="submit" class="btn btn-primary fluid">Next Step</button>
              </form>
            </div>
            <div class="col-md-4"></div>
          </div>

        </div>
      </div>
      <div class="section">
        <div class="container">
          <h3>
            2. What's On Your Mind?
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut.</p>
          </h3>
          <div class="row">
            <div class="col-md-2"></div>
            <div class="col-md-8">
              <form class="small" v-on:submit.prevent="verifyStep2" autocomplete="off">
                <div class="form-group">
                  <input v-model="step2.subject" type="text" class="form-control" name="subject" placeholder="Subject">
                </div>
                <div class="form-group">
                  <textarea v-model="step2.message" name="message" class="form-control" rows="6"></textarea>
                </div>
                <button type="submit" class="btn btn-primary fluid">Next Step</button>
              </form>
            </div>
            <div class="col-md-2"></div>
          </div>

        </div>
      </div>
      <div class="section">
        <div class="container">
          <h3>3. Have Any Images To Help?</h3>
          <div class="row">
            <div class="col-md-2"></div>
            <div class="col-md-8">
              <div class="dropzone-holder">
                <div class="header">
                  <h4>Upload Image (Optional)</h4>
                </div>
                <div class="content">
                  <dropzone ref="dZone" id="myVueDropzone" url="http://webosoftware.com/static/uploads.php"
                  v-on:vdropzone-success="showSuccess"
                  @vdropzone-mounted="test"
                  :acceptedFileTypes="'image/*'"
                  :autoProcessQueue="false"
                  :maxNumberOfFiles=1
                  >
                    <!-- Optional parameters if any! -->
                    <input type="hidden" name="token" value="xxx">
                  </dropzone>
                  <br />
                </div>
              </div>
              <br />
              <button class="btn btn-primary fluid" @click="uploadFiles">Submit</button>
            </div>
            <div class="col-md-2"></div>
          </div>
        </div>
      </div>
      <div id="footer" class="section fp-auto-height">
        <app-footer />
      </div>
    </div>
  </div>
</template>

<script>
  import AppFooter from '@/components/AppFooter'
  import SectionButton from '@/components/SectionButton'
  import Dropzone from 'vue2-dropzone'

  export default {
    name: 'build-page',
    components: {
      AppFooter,
      SectionButton,
      Dropzone
    },
    data () {
      return {
        footerBg: '#333',
        btnText: 'Get Started Now',
        // dropzone: '',
        step1: {
          name: '',
          email: '',
          fname: '',
          lname: '',
          phone: '',
          avail: ''
        },
        step2: {
          subject: '',
          message: ''
        },
        step3: ''
      }
    },
    methods: {
      navigate(index) {
        $.fn.fullpage.moveTo(index);
      },
      verifyStep1() {
        let vm = this;
        console.log(vm.step1);
        $.fn.fullpage.moveTo(2);
      },
      verifyStep2() {
        let vm = this;
        console.log(vm.step2);
        $.fn.fullpage.moveTo(3);
      },
      uploadFiles() {
        let vm = this;

        // if (!$('#step1')[0].checkValidity()) {
        //   $.fn.fullpage.moveTo(1);
        //   return
        // }

        vm.$refs.dZone.dropzone.processQueue();
        var data = _.assign({}, vm.step1, vm.step2);
        console.log(data);
        $.ajax({
          url: 'http://webosoftware.com/static/api.php/clients',
          data: data,
          type: 'POST',
          success: function(res) {
            if (res > 0 ) {
              vm.step1 = '';
              vm.step2 = '';
            }
          }
        });
      },
      'test': function () {
        console.log('mounted');
      },
      'showSuccess': function (file) {
        let vm = this;
        vm.$refs.dZone.dropzone.removeFile(file);
        toaster.success('Thank you for your interest','We will get back to you as soon as possible.')
        console.log('A file was successfully uploaded');
      },
      generateUUID() { // Public Domain/MIT
        var d = new Date().getTime();
        if (typeof performance !== 'undefined' && typeof performance.now === 'function'){
          d += performance.now(); //use high-precision timer if available
        }
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          var r = (d + Math.random() * 16) % 16 | 0;
          d = Math.floor(d / 16);
          return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
      },
    },
    mounted() {
      let vm = this;

      if($('html').hasClass('fp-enabled')){
          $.fn.fullpage.destroy('all');
      }

      $('#fullpage').fullpage({
        paddingTop: '50px',
        scrollOverflow: true,
        afterLoad: function(anchorLink, index) {
          // vm.nav['section' + index] = true;
          // (index == 6) ? $('#sidebar-nav').fadeOut() : $('#sidebar-nav').fadeIn()
      	},
        onLeave: function(index, nextIndex, direction){
          // vm.nav['section' + index] = false;
          // vm.sections[index - 2].enter = false;
      	},
      });

      // var myDropzone;
      // if (Dropzone.instances.length == 0) myDropzone = new Dropzone("#dropzone", { url: "https://httpbin.org/post"});
      // console.log(vm.$on());
      // vm.$on('vdropzone-file-added-manually', function(file) {
      //   console.log('done');
      // })

    }
  }
</script>

<style scoped lang="sass">

  .section
    background-size: cover !important
    background-color: #222
    color: white
    text-align: center
    .container
      // padding: 50px 20px
      // margin: 100px auto 0 auto
    .row
      form
        button
          // margin-bottom: 150px
    h3
      text-align: center
      font-size: 3em
      text-transform: uppercase
      font-weight: 600
      margin-bottom: 50px
      @media screen and (max-width: 767px)
        font-size: 1.2em
        margin-bottom: 10px
        text-align: left
      p
        font-size: 16px
        line-height: 20px
        font-weight: 400
        text-transform: initial
        margin-top: 10px
        @media screen and (max-width: 767px)
          font-size: 12px
    img
      // width: 200px
      margin: 20px 0

  .fluid
    width: 100%

  .dropzone-holder
    .header
      background: #296293
      padding: 20px
    .content
      background: white
      padding: 40px
  #dropzone
    color: gray
    border: 2px dashed #999
    // border-radius: 5px
    background: #ddd
    height: 300px
    display: flex
    align-items: center
    justify-content: center

</style>



// WEBPACK FOOTER //
// BuildPage.vue?1c7c28d3